var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 105,
    viewBox: "0 0 102 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20111_26845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3586 59.0679H16.252V91.5132C16.252 93.0608 17.2667 94.4261 18.7495 94.8713C25.7935 96.9833 45.6021 102.927 50.2975 104.336C50.9547 104.532 51.6558 104.532 52.3131 104.336C57.0084 102.927 76.8171 96.9833 83.861 94.8713C85.3438 94.4261 86.3586 93.0608 86.3586 91.5132C86.3586 83.3879 86.3586 59.0679 86.3586 59.0679Z",
    fill: "url(#paint0_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3548 59.0679H51.3015C51.3015 59.0679 50.9615 104.483 51.3015 104.483C51.6415 104.483 51.9798 104.434 52.3093 104.336C57.0047 102.927 76.8133 96.9833 83.8573 94.8713C85.34 94.4261 86.3548 93.0608 86.3548 91.5132C86.3548 83.3879 86.3548 59.0679 86.3548 59.0679Z",
    fill: "url(#paint1_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.305 70.4409L16.2517 59.0679C16.2517 59.0679 10.1051 68.1817 7.35696 72.2549C7.04849 72.7124 6.97312 73.2855 7.15189 73.806C7.33242 74.3266 7.7443 74.7314 8.26834 74.9032C14.9267 77.066 34.6372 83.4702 39.8076 85.1493C40.5489 85.3912 41.3622 85.1125 41.8003 84.4658C44.1507 80.9972 51.305 70.4409 51.305 70.4409Z",
    fill: "url(#paint2_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.358 59.0679L51.3047 70.4409C51.3047 70.4409 58.4591 80.9972 60.8094 84.4658C61.2476 85.1125 62.0608 85.3912 62.8022 85.1493C67.9725 83.4702 87.683 77.066 94.3414 74.9032C94.8654 74.7314 95.2773 74.3266 95.4578 73.806C95.6366 73.2855 95.5613 72.7124 95.2528 72.2549C92.5046 68.1817 86.358 59.0679 86.358 59.0679Z",
    fill: "url(#paint3_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8179 35.1751C42.3798 34.5319 41.5683 34.2532 40.8269 34.495C35.66 36.1723 15.9443 42.5783 9.28592 44.7429C8.76187 44.9129 8.34824 45.3178 8.16947 45.8383C7.9907 46.3588 8.06606 46.9337 8.37453 47.3894C10.9054 51.1436 16.2493 59.0657 16.2493 59.0657L51.3026 47.6541C51.3026 47.6541 45.007 38.3947 42.8179 35.1751Z",
    fill: "url(#paint4_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2327 47.3894C94.5412 46.9337 94.6166 46.3588 94.4378 45.8383C94.259 45.3178 93.8454 44.9129 93.3213 44.7429C86.663 42.5783 66.9472 36.1723 61.7804 34.495C61.039 34.2532 60.2275 34.5319 59.7893 35.1751C57.6003 38.3947 51.3047 47.6541 51.3047 47.6541L86.358 59.0657C86.358 59.0657 91.7019 51.1436 94.2327 47.3894Z",
    fill: "url(#paint5_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3586 59.0688L51.3053 47.6572L16.252 59.0688L51.3053 70.4419L86.3586 59.0688Z",
    fill: "url(#paint6_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3053 70.4419V47.6572L16.252 59.0688L51.3053 70.4419Z",
    fill: "url(#paint7_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2628 52.6862C43.5337 52.2095 42.8765 51.6995 42.2928 51.1649C41.5812 50.5112 40.4718 50.5585 39.8163 51.2718C39.1626 51.9834 39.2099 53.0929 39.9232 53.7466C40.6401 54.4056 41.448 55.0331 42.3454 55.6202C43.1551 56.1495 44.2418 55.9217 44.7711 55.1119C45.3004 54.3022 45.0725 53.2156 44.2628 52.6862Z",
    fill: "url(#paint8_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8069 47.3033C38.2863 46.597 37.8464 45.8872 37.4854 45.1774C37.0472 44.315 35.9903 43.9715 35.128 44.4097C34.2657 44.8479 33.9222 45.9047 34.3604 46.767C34.8055 47.6398 35.3454 48.5144 35.9851 49.382C36.5582 50.1602 37.6554 50.3267 38.4353 49.7536C39.2135 49.1787 39.38 48.0815 38.8069 47.3033Z",
    fill: "url(#paint9_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2422 40.144C36.2597 39.4376 36.3631 38.7523 36.5524 38.0951C36.8188 37.1662 36.2807 36.1935 35.3501 35.9271C34.4211 35.6606 33.4484 36.1987 33.182 37.1294C32.9138 38.0688 32.7631 39.0485 32.7368 40.0563C32.714 41.0238 33.4782 41.8283 34.4457 41.8511C35.4131 41.8756 36.2176 41.1114 36.2422 40.144Z",
    fill: "url(#paint10_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9373 34.2919C39.3877 33.8747 39.8925 33.4891 40.4446 33.1404C41.2631 32.6233 41.5084 31.5402 40.9931 30.7234C40.4761 29.9049 39.393 29.6596 38.5745 30.1749C37.8331 30.6428 37.1601 31.1599 36.5554 31.7207C35.8456 32.378 35.8035 33.4874 36.4608 34.1972C37.118 34.9071 38.2274 34.9491 38.9373 34.2919Z",
    fill: "url(#paint11_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4544 31.2672C46.336 31.1042 47.2702 30.9991 48.2552 30.9587C49.2227 30.9167 49.9728 30.0982 49.9325 29.1325C49.8922 28.1667 49.0737 27.4149 48.1062 27.4552C46.9495 27.5042 45.8523 27.6287 44.8165 27.8197C43.8665 27.9967 43.2356 28.9116 43.4126 29.8616C43.5878 30.8133 44.5027 31.4425 45.4544 31.2672Z",
    fill: "url(#paint12_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5912 31.1649C56.0862 31.1824 57.4778 31.1298 58.7695 31.0159C59.7335 30.93 60.4468 30.0782 60.3609 29.1143C60.2751 28.152 59.4233 27.4387 58.4593 27.5246C57.2762 27.628 56.0021 27.6771 54.6315 27.6595C53.664 27.649 52.87 28.4255 52.8595 29.3912C52.8472 30.3586 53.6237 31.1544 54.5912 31.1649Z",
    fill: "url(#paint13_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5323 29.9392C66.2674 29.4081 67.7326 28.7281 68.9595 27.9482C69.7745 27.4276 70.0164 26.3445 69.4958 25.5277C68.977 24.7127 67.8921 24.4709 67.0754 24.9914C66.0886 25.6189 64.9056 26.1587 63.507 26.5863C62.5833 26.8703 62.061 27.85 62.3449 28.7754C62.6271 29.7008 63.6086 30.2214 64.5323 29.9392Z",
    fill: "url(#paint14_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4505 23.0466C74.2777 21.336 74.595 19.5272 74.5143 17.7833C74.4688 16.8158 73.6468 16.0692 72.6811 16.1148C71.7153 16.1603 70.9669 16.9806 71.0125 17.9463C71.0686 19.1311 70.8548 20.3597 70.2939 21.5217C69.8733 22.3928 70.2378 23.4427 71.1089 23.8633C71.98 24.2839 73.0298 23.9176 73.4505 23.0466Z",
    fill: "url(#paint15_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.332 11.584C71.0543 9.85767 69.3209 8.65534 67.4316 8.268C66.4834 8.07521 65.5562 8.68513 65.3617 9.63333C65.1689 10.5815 65.7806 11.5087 66.727 11.7032C67.8172 11.9258 68.7776 12.6742 69.5155 13.6715C70.0921 14.4479 71.191 14.6109 71.9675 14.036C72.7457 13.4594 72.9087 12.3605 72.332 11.584Z",
    fill: "url(#paint16_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4355 8.61517C51.3319 -2.12341 67.7667 -1.42935 58.1989 8.61517H49.4355Z",
    fill: "url(#paint17_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4355 11.3374C51.3319 22.0742 67.7667 21.3819 58.1989 11.3374H49.4355Z",
    fill: "url(#paint18_linear_20111_26845)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2742 11.7441H61.01C61.9775 11.7441 62.7627 10.9589 62.7627 9.99144C62.7627 9.02396 61.9775 8.23877 61.01 8.23877H49.2742C48.3084 8.23877 47.5215 9.02396 47.5215 9.99144C47.5215 10.9589 48.3084 11.7441 49.2742 11.7441Z",
    fill: "url(#paint19_linear_20111_26845)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20111_26845",
    x1: 16.252,
    y1: 81.7754,
    x2: 86.3586,
    y2: 81.7754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20111_26845",
    x1: 51.1508,
    y1: 81.7754,
    x2: 86.3548,
    y2: 81.7754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20111_26845",
    x1: 16.4848,
    y1: 59.0538,
    x2: 21.384,
    y2: 91.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20111_26845",
    x1: 51.4467,
    y1: 70.3217,
    x2: 88.3994,
    y2: 91.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20111_26845",
    x1: 11.6608,
    y1: 52.2636,
    x2: 16.9486,
    y2: 27.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20111_26845",
    x1: 60.6885,
    y1: 34.0727,
    x2: 62.5793,
    y2: 64.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20111_26845",
    x1: 16.252,
    y1: 59.0496,
    x2: 86.3586,
    y2: 59.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_20111_26845",
    x1: 54.8947,
    y1: 47.1472,
    x2: 55.6501,
    y2: 75.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_20111_26845",
    x1: 32.0099,
    y1: 8.61196,
    x2: 66.5795,
    y2: 49.4017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_20111_26845",
    x1: 32.0153,
    y1: 8.61323,
    x2: 66.5849,
    y2: 49.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_20111_26845",
    x1: 32.013,
    y1: 8.60651,
    x2: 66.5825,
    y2: 49.3963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_20111_26845",
    x1: 32.0125,
    y1: 8.6083,
    x2: 66.5821,
    y2: 49.3981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_20111_26845",
    x1: 32.0115,
    y1: 8.60698,
    x2: 66.5811,
    y2: 49.3968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_20111_26845",
    x1: 32.0133,
    y1: 8.60807,
    x2: 66.5829,
    y2: 49.3979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_20111_26845",
    x1: 32.0151,
    y1: 8.60573,
    x2: 66.5847,
    y2: 49.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_20111_26845",
    x1: 32.0122,
    y1: 8.60986,
    x2: 66.5818,
    y2: 49.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_20111_26845",
    x1: 32.0102,
    y1: 8.60802,
    x2: 66.5798,
    y2: 49.3978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_20111_26845",
    x1: 49.4355,
    y1: 4.71724,
    x2: 61.1696,
    y2: 4.71724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_20111_26845",
    x1: 49.4355,
    y1: 15.2353,
    x2: 61.1696,
    y2: 15.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_20111_26845",
    x1: 32.0069,
    y1: 8.61384,
    x2: 66.5765,
    y2: 49.4036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20111_26845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 104.885,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/emptyFolder.bd027a96b3f9138a32e496c83e69ca66.svg";
export { ForwardRef as ReactComponent };